import { useContext, useEffect, useMemo, useState } from "react";
import { Scenario, Stage, Step } from "../../api/model/scenario";
import { TravelQuotationContext } from "../../contexts/TravelQuotationContext";
import { TravelScenarioContext } from "../../contexts/TravelScenatioContext";
import { quotationStatusList, TravelQuotation } from "../../model/quotation";
import { FindOnTravel } from "../findOnTravel";
import "./index.scss";
import { TravelStageComponent } from "./Stage";

interface ScenarioComponentProps {
    scenario: Scenario;
    onCustomerFound: () => void;
}

export const TravelScenarioComponent = ({ scenario, onCustomerFound }: ScenarioComponentProps) => {
    const { quotation, setQuotation, tab, setTab, setFoundPrimaryInsured, tariffied } =
        useContext(TravelQuotationContext);

    const [currentStage, setCurrentStage] = useState<Stage>(
        scenario.stages.find((value) => value.quotationStatus === quotation.status),
    );

    const getCurrentStep = () => {
        const searchedStep = localStorage.getItem("TRAVEL_step") || quotation?.currentStep;
        return searchedStep && currentStage.steps.some((step) => step.code === searchedStep)
            ? currentStage.steps.find((step) => step.code === searchedStep)
            : currentStage.steps[0];
    };

    const [currentStep, setCurrentStep] = useState<Step>(getCurrentStep());

    const [previousStep, setPreviousStep] = useState<Step>(null);

    const nextStageHandler = (_: TravelQuotation) => {
        const currentStageIndex = scenario.stages.indexOf(currentStage);
        const nextStage = scenario.stages[currentStageIndex + 1];
        setCurrentStage(nextStage);
        setCurrentStep(nextStage.steps[0]);
        window.scrollTo(0, 0);
    };

    const backStageHandler = (quotation: TravelQuotation) => {
        const currentStageIndex = scenario.stages.indexOf(currentStage);
        const nextStage = scenario.stages[currentStageIndex - 1];
        setCurrentStage(nextStage);
        setCurrentStep(nextStage.steps[0]);
        quotation.status = quotationStatusList[currentStageIndex - 1];
        setQuotation(quotation);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        localStorage.setItem("TRAVEL_step", currentStep.code);
    }, [currentStep]);

    const providerValues = useMemo(
        () => ({
            currentStep,
            setCurrentStep,
            previousStep,
            setPreviousStep,
            nextStageHandler,
            backStageHandler,
        }),
        [currentStep, previousStep, nextStageHandler, backStageHandler],
    );

    return (
        <TravelScenarioContext.Provider value={providerValues}>
            <div
                className={`travel-scenario__wrapper ${tariffied ? "" : "travel-scenario__wrapper--with_tabs"}`}
            >
                {tab === "firstTime" ? (
                    <TravelStageComponent stage={currentStage} />
                ) : (
                    <FindOnTravel
                        onCustomerFound={(information) => {
                            /*
                                        Я роблю деліт із-за того, що валідація на них ругається та вважає їх неприйнятними,
                                        хоча вона прилітають з апішки -_-
                                        Далі кладемо отриману інфу в тимчасовий стейт,
                                        даємо команду убрати можливість переключатись між табами
                                        та переключаємось на першой крок таби "купаю вперше"
                                    */
                            information.givenName = information.translitGivenName;
                            information.surname = information.translitSurname;
                            delete information.ipn;
                            delete information.middleName;
                            delete information.translitSurname;
                            delete information.translitGivenName;
                            setFoundPrimaryInsured(information);
                            onCustomerFound();
                            setTab("firstTime");
                        }}
                    />
                )}
            </div>
        </TravelScenarioContext.Provider>
    );
};
